import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    currentPage:1
}
const createListReducer = createSlice({
    name:'commonMethodsReducer',
    initialState,
    reducers:{
        setCurrentPage(state,action) { // 修改页数
            state.currentPage = action.payload
        }
    }
})

export const { setCurrentPage } = createListReducer.actions

export default createListReducer.reducer